export default function GitHub({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("GitHub")}</legend>
      <input
        onChange={onChange}
        value={searchObject.gitHub || ""}
        name="gitHub"
        className="form-control fontsize-legend"
      />{" "}
    </div>
  );
}
